import React from 'react';
import { useTranslation } from 'react-i18next';

interface PlaceholderProps {
    pageKey: string;
}

const Placeholders: React.FC<PlaceholderProps> = ({ pageKey }) => {
    const { t } = useTranslation();
    const pageName = t(pageKey);

    return (
        <div className='flex flex-col items-center justify-center h-full min-h-[60vh] bg-white dark:bg-gray-800 rounded-xl shadow-sm'>
            <div className="text-center text-gray-500 dark:text-gray-400">
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-200">{t('placeholders.title', { page: pageName })}</h1>
                <p className="mt-2">{t('placeholders.underConstruction')}</p>
            </div>
        </div>
    );
};

export default Placeholders;